// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_sidebar__5jBK6 {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-right: 20px;
  position: sticky;
  top: 10px;
  align-self: flex-start;
  transition: width 0.3s ease;
  width: auto;
}
@media (max-width: 767px) {
  .styles_sidebar__5jBK6 {
    width: 60px;
    padding-right: 0;
  }
  .styles_sidebar__5jBK6 .styles_tab__0dVL4,
  .styles_sidebar__5jBK6 .styles_exitTab__QSTki {
    justify-content: center;
    padding-left: 0;
    padding-right: 0;
  }
  .styles_sidebar__5jBK6 .styles_tab__0dVL4 span,
  .styles_sidebar__5jBK6 .styles_exitTab__QSTki span {
    display: none;
  }
}
.styles_sidebar__5jBK6.styles_collapsed__\\+VZX7 {
  width: 60px;
  padding-right: 0;
}
.styles_sidebar__5jBK6.styles_collapsed__\\+VZX7 .styles_tab__0dVL4,
.styles_sidebar__5jBK6.styles_collapsed__\\+VZX7 .styles_exitTab__QSTki {
  justify-content: center;
  padding-left: 0;
  padding-right: 0;
}
.styles_sidebar__5jBK6.styles_collapsed__\\+VZX7 .styles_tab__0dVL4 span,
.styles_sidebar__5jBK6.styles_collapsed__\\+VZX7 .styles_exitTab__QSTki span {
  display: none;
}

.styles_tab__0dVL4 {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border: none;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  color: #64748b;
  transition: all 0.15s ease;
  text-align: left;
  width: 100%;
}
.styles_tab__0dVL4:hover {
  background: #f1f5f9;
  color: #334155;
}
.styles_tab__0dVL4:hover .styles_tabIcon__89niK {
  color: #334155;
}
.styles_tab__0dVL4.styles_active__A0rCQ {
  color: #2563eb;
}
.styles_tab__0dVL4.styles_active__A0rCQ .styles_tabIcon__89niK {
  color: #2563eb;
  filter: invert(37%) sepia(74%) saturate(2254%) hue-rotate(212deg) brightness(97%) contrast(93%);
}

.styles_tabIcon__89niK {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  color: #64748b;
  transition: color 0.15s ease;
}

.styles_exitTab__QSTki {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 32px;
  border: none;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  color: #191919;
  transition: all 0.15s ease;
  width: 100%;
}
.styles_exitTab__QSTki:hover {
  background: #f1f5f9;
  color: #191919;
}

.styles_exitIcon__Ijh9W {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/sidebar/styles.module.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,sBAAA;EACA,2BAAA;EACA,WAAA;AAAF;AAEE;EAXF;IAYI,WAAA;IACA,gBAAA;EACF;EACE;;IAEE,uBAAA;IACA,eAAA;IACA,gBAAA;EACJ;EACI;;IACE,aAAA;EAEN;AACF;AAIE;EACE,WAAA;EACA,gBAAA;AAFJ;AAII;;EAEE,uBAAA;EACA,eAAA;EACA,gBAAA;AAFN;AAIM;;EACE,aAAA;AADR;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,gBAAA;EACA,WAAA;AAJF;AAME;EACE,mBAAA;EACA,cAAA;AAJJ;AAMI;EACE,cAAA;AAJN;AAQE;EACE,cAAA;AANJ;AAQI;EACE,cAAA;EAEA,+FAAA;AAPN;;AAYA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,4BAAA;AATF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,WAAA;AATF;AAWE;EACE,mBAAA;EACA,cAAA;AATJ;;AAaA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAVF","sourcesContent":["@import \"mixins\";\n.sidebar {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding-right: 20px;\n  position: sticky;\n  top: 10px;\n  align-self: flex-start;\n  transition: width 0.3s ease;\n  width: auto;\n\n  @media (max-width: 767px) {\n    width: 60px;\n    padding-right: 0;\n    \n    .tab,\n    .exitTab {\n      justify-content: center;\n      padding-left: 0;\n      padding-right: 0;\n      \n      span {\n        display: none;\n      }\n    }\n\n  }\n\n  // Collapsed state for desktop\n  &.collapsed {\n    width: 60px;\n    padding-right: 0;\n    \n    .tab,\n    .exitTab {\n      justify-content: center;\n      padding-left: 0;\n      padding-right: 0;\n      \n      span {\n        display: none;\n      }\n    }\n  }\n}\n\n.tab {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n  border: none;\n  background: transparent;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 500;\n  color: #64748b;\n  transition: all 0.15s ease;\n  text-align: left;\n  width: 100%;\n\n  &:hover {\n    background: #f1f5f9;\n    color: #334155;\n\n    .tabIcon {\n      color: #334155;\n    }\n  }\n\n  &.active {\n    color: #2563eb;\n\n    .tabIcon {\n      color: #2563eb;\n      // Use filter to colorize SVG icons that don't use currentColor\n      filter: invert(37%) sepia(74%) saturate(2254%) hue-rotate(212deg) brightness(97%) contrast(93%);\n    }\n  }\n}\n\n.tabIcon {\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n  color: #64748b;\n  transition: color 0.15s ease;\n}\n\n.exitTab {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 32px;\n  border: none;\n  background: transparent;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 500;\n  color: #191919;\n  transition: all 0.15s ease;\n  width: 100%;\n\n  &:hover {\n    background: #f1f5f9;\n    color: #191919;\n  }\n}\n\n.exitIcon {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `styles_sidebar__5jBK6`,
	"tab": `styles_tab__0dVL4`,
	"exitTab": `styles_exitTab__QSTki`,
	"collapsed": `styles_collapsed__+VZX7`,
	"tabIcon": `styles_tabIcon__89niK`,
	"active": `styles_active__A0rCQ`,
	"exitIcon": `styles_exitIcon__Ijh9W`
};
export default ___CSS_LOADER_EXPORT___;
